<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-150 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-if="confirmState.open"
        class="fixed inset-0 z-90 flex items-center justify-center bg-black/50 p-4"
        @click.self="settleConfirm(false)"
        @keydown.esc="settleConfirm(false)"
      >
        <div
          role="alertdialog"
          aria-modal="true"
          :aria-label="confirmState.options.title"
          class="w-full max-w-md rounded-lg bg-white p-6 shadow-xl"
        >
          <h3 class="text-lg font-medium text-gray-900">{{ confirmState.options.title }}</h3>
          <p class="mt-2 whitespace-pre-line text-sm text-gray-600">{{ confirmState.options.message }}</p>
          <div class="mt-6 flex justify-end gap-3">
            <button
              type="button"
              class="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
              @click="settleConfirm(false)"
            >
              {{ confirmState.options.cancelLabel }}
            </button>
            <button
              ref="confirmButton"
              type="button"
              class="rounded-md px-4 py-2 text-sm font-medium text-white focus:outline-hidden focus:ring-2 focus:ring-offset-2"
              :class="confirmState.options.variant === 'danger'
                ? 'bg-red-600 hover:bg-red-700 focus:ring-red-500'
                : 'bg-brand-dark hover:bg-brand-dark-light focus:ring-brand-yellow'"
              @click="settleConfirm(true)"
            >
              {{ confirmState.options.confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { nextTick, ref, watch } from 'vue'
import { confirmState, settleConfirm } from '@/composables/useConfirm'

const confirmButton = ref<HTMLButtonElement | null>(null)

// Focus op de bevestigingsknop zodra de dialoog opent, zodat Enter/Escape
// meteen werken (zoals bij window.confirm).
watch(
  () => confirmState.open,
  async open => {
    if (open) {
      await nextTick()
      confirmButton.value?.focus()
    }
  }
)
</script>
